export function scaleByDevicePixelRatio(canvas: HTMLCanvasElement, width: number, height: number) {
  const context = canvas.getContext('2d')!
  const dpr = window.devicePixelRatio
  canvas.style.width = `${width}px`
  canvas.style.height = `${height}px`
  canvas.width = width * dpr
  canvas.height = height * dpr
  context.scale(dpr, dpr)
}
